import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
import {FilePdfTwoTone} from '@ant-design/icons';
const {Text} = Typography;
const Content = Layout;

const AP = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Content style={{background: 'inherit'}}>
          <Text className='BaseText6'>The purpose of this protocol is to see the proper interaction between the aptamers with a biotin modification and the streptavidin, as they should bind between each other by the biotin-streptavidin strong interaction.</Text>
          <Layout style={{background: 'transparent'}}>
            <Content style={{marginLeft: '50%', transform: 'translateX(-50%)', marginTop: '2vh', width: '90vh', background: 'transparent'}}>
              <iframe title="TecCCM: Alginate Pearls (2022) [English]" height="515" src="https://video.igem.org/videos/embed/a5cb21db-2b1b-40d0-b834-3b2ffc10a596" allowfullscreen="" sandbox="allow-same-origin allow-scripts allow-popups"></iframe>
              <Content style={{width: '15vh', marginLeft: '54vh', background: 'transparent'}}><p><i>Go to pdf</i></p></Content>
              <a style={{width: 'fit-content', marginLeft: '58vh'}} target='_blank' rel='noopener noreferrer' href='https://static.igem.wiki/teams/4464/wiki/wet-lab/pdfs/5-alginate-pearls.pdf'><FilePdfTwoTone style={{fontSize: '8vh'}} twoToneColor='#eb2f96'/></a>
            </Content>
          </Layout>
        </Content>
        <Divider/>
      </Layout>
    </Layout>
  );
};

export default AP;
